export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const COMMIT_LOGS_API_URL = '/api/logs/commit'
export const AUTH_API_URL = '/auth/verify'
export const LOGIN_API_URL = '/auth/login'
export const REGISTER_API_URL = '/auth/register'
export const PASSWORD_RESET_REQUEST_API_URL = '/auth/password/reset/request'
export const PASSWORD_RESET_API_URL = '/auth/password/reset'
export const USER_RESET_API_URL = '/auth/user/password/reset/request'
export const UPDATE_USER_INFO_API_URL = '/auth/update/info'
export const LINKS_API_ROUTE = '/admin/v1/links'
export const EDIT_LINK_API_URL_SUFFIX = 'edit'
export const DELETE_LINK_API_URL_SUFFIX = 'close'
export const CREATE_LINK_API_URL_SUFFIX = 'create'
export const UPLOAD_FILE_API_URL = '/admin/v1/file/upload'
export const PRODUCT_SEARCH_API_URL = '/admin/v1/products/search'
export const AUTH_STORE_CONNECT_API_URL_PREFIX = '/admin/v1/store'
export const AUTH_STORE_CONNECT_API_URL = '/auth/connect'
export const STORE_CONNECT_API_URL = '/connect'
export const STORE_DISCONNECT_API_URL = '/disconnect'
export const BUSINESS_SETTINGS_API_URL = '/admin/v1/businesses/settings'
export const UPGRADE_PRICING_PLAN_API_URL = AUTH_STORE_CONNECT_API_URL_PREFIX + '/plan/upgrade/request'
export const CANCEL_PRICING_PLAN_API_URL = AUTH_STORE_CONNECT_API_URL_PREFIX + '/plan/cancel'
export const BUSINESS_ANALYTICS_API_URL_PREFIX = LINKS_API_ROUTE + '/analytics/business'
export const LINK_ANALYTICS_API_URL_PREFIX = LINKS_API_ROUTE + '/analytics/username'
export const ANALYTICS_API_URL_SUFFIX = '/overview'
export const VALIDATE_USERNAME_API_URL = '/auth/validate/username'
export const VALIDATE_EMAIL_API_URL = '/auth/validate/email'
export const STORE_SETTINGS_API_URL_PREFIX = AUTH_STORE_CONNECT_API_URL_PREFIX
export const STORE_SETTINGS_API_URL_SUFFIX = '/settings'
export const STORE_APPEARANCE_SETTINGS_API_URL_SUFFIX = '/appearance'
export const STORE_SETTINGS_PRODUCT_SYNC_API_URL_SUFFIX = '/sync'
export const STORE_SETTINGS_THEME_UPDATE_API_URL_SUFFIX = '/theme'
export const ARCHIVE_LINKS_API_URL_PREFIX = LINKS_API_ROUTE
export const ARCHIVE_LINKS_API_URL_SUFFIX = '/archive'
export const ACCOUNT_VERIFICATION_API_URL = '/auth/account/verify'
export const REGISTRATION_REQUEST_API_URL = '/auth/register/request'